import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-progress-circle',
	templateUrl: 'progress-circle.component.html',
	standalone: false,
})
export class ProgressCircleComponent {
	@Input() percentage: number;
	@Input() size: 'small' | 'medium' = 'small';

	get colorByPercentage() {
		if (this.percentage < 50) return 'red';

		if (this.percentage > 50 && this.percentage < 75) return 'orange';

		if (this.percentage > 75 && this.percentage < 100) return 'green';

		if (this.percentage === 100) return 'lightgreen';
	}
}
